
import { defineComponent, ref, Ref } from "vue";

import {
	addPaddingZeros,
	getKeyofCurrentDay,
	getKeyofCurrentMonth
} from "@/utils/dataFormatting";
import idb from "@/utils/idb";
import ClockFace from "../components/ClockFace.vue";

export default defineComponent({
	components: {
		ClockFace
	},

	setup() {
		const now: Ref<String> = ref(
			`${addPaddingZeros(new Date().getHours())}:${addPaddingZeros(
				new Date().getMinutes()
			)}`
		);

		const itemsLength: Ref<number> = ref(0);

		const getItemsLength = async () => {
			const items = await idb.getItems("todos");
			itemsLength.value = items ? items.length : 0;
		};

		getItemsLength();

		const dayOfTheWeek: string = getKeyofCurrentDay(new Date().getDay());
		const monthOfTheYear: string = getKeyofCurrentMonth(
			new Date().getMonth()
		);

		return {
			now,
			dayOfTheWeek,
			monthOfTheYear,
			itemsLength
		};
	}
});
